import Route from '@ember/routing/route';

import { set } from '@ember/object';

/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      route — thin: only collapses the cart/menu chrome on entry. Despite the
 *              name, controllers/index.js is the booking wizard, not the storefront
 *              homepage this route serves — no model load happens here.
 *   extends:   Route (@ember/routing/route)
 *   template:  none
 *   model:     - (no model hook)
 *   key:       setupController
 *   uses:      application controller (collapses cart/menu chrome)
 *   siblings:  controllers/index.js (booking wizard state, unrelated to this route)
 *   tests:     simple-routes-test.js ("index route collapses the cart and menu chrome")
 *   gotchas:   -
 *
 * Storefront homepage route — chrome collapse only.
 */
export default class IndexRoute extends Route {
  setupController(/*controller*/) {
    var application = this.controllerFor('application');
    set(application, 'showCart', null);
    set(application, 'showMenu', null);
    //application.loadDataTask.perform();
  }
}
